module.exports = __webpack_public_path__ + "static/media/cloudchat.69e5ed5c.png";